var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneHeader = function SvgPhoneHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.507 9.291c.361.128 2.3 1.079 2.69 1.278.39.191.653.29.745.468.1.163.1.951-.227 1.874s-1.895 1.76-2.655 1.874c-1.25.184-2.229.092-4.727-.987-3.954-1.71-6.53-5.685-6.729-5.948C1.412 7.588 0 5.714 0 3.776S1.015.887 1.377.49C1.739.1 2.165 0 2.427 0c.263 0 .526 0 .753.014.241.014.568-.092.887.674.327.788 1.114 2.726 1.214 2.925s.163.426.035.688C4.564 5.806 3.755 5.756 4.16 6.452c1.526 2.62 3.045 3.528 5.36 4.685.39.198.624.163.851-.1.234-.27.987-1.15 1.25-1.547.262-.398.525-.334.887-.199"
  })));
};
export default SvgPhoneHeader;